/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import { MantenedorService } from '../home/services/mantenedor.service';

@Injectable({
  providedIn: 'root',
})
export class CommmonService {
  
  constructor(private mantenedorService: MantenedorService) {

  }
  
  sortArray(jsonData: any) {
    const compareIds = (a: any, b: any) => {
      return a.id - b.id;
    };

    return jsonData.sort(compareIds);
  }

  generate_id(): string {
    const now = new Date();
    const id =
      now.getFullYear().toString() +
      (now.getMonth() + 1).toString().padStart(2, '0') +
      now.getDate().toString().padStart(2, '0') +
      now.getHours().toString().padStart(2, '0') +
      now.getMinutes().toString().padStart(2, '0') +
      now.getSeconds().toString().padStart(2, '0');
    return id;
  }

  getToDate() {
    let d = new Date(),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2) 
        month = '0' + month;
    if (day.length < 2) 
        day = '0' + day;

    return [year, month, day].join('-');
  }

  formatear_fecha(fecha: string=""): string {
  if (fecha.length !== 0) {
    const fechaT = new Date(fecha);
    const dia: string = ('0' + fechaT.getDate()).slice(-2);
    const mes: string = ('0' + (fechaT.getMonth() + 1)).slice(-2);
    const anio: number = fechaT.getFullYear();
    return `${anio}-${mes}-${dia}`;
  } else {
    const vacio = '';
    return vacio;
  }
}

  getItemLocalStorage(item: string) {
    return localStorage.getItem(item);
  }

  stringToDate(fechaOriginal: string) {
    const [dia, mes, anio] = fechaOriginal.split("-");
    const fecha = new Date(parseInt(anio), parseInt(mes) - 1, parseInt(dia));
    const fechaISO = fecha.toISOString();
    return fechaISO;
  }

  getItemSessionStorage(item: string) {
    return sessionStorage.getItem(item);
  }

  setItemSessionStorage(key: string, item: string) {
    sessionStorage.setItem(key, item);
  }

  setItemLocalStorage(key: string, item: string) {
    localStorage.setItem(key, item);
  }

  removeItemLocalStorage(key: string) {
    localStorage.removeItem(key);
  }

  removeItemSessionStorage(key: string) {
    sessionStorage.removeItem(key);
  }

  async get_fechas_contrato_colectivo(categoria: number) {
    const response = await this.mantenedorService.getMantenedoresByCategoria(categoria);
    return response.data;
  }

  async get_datos_manatenedor_categoria(categoria: number) {
    const response = await this.mantenedorService.getMantenedoresByCategoria(categoria);
    return response.data;
  }
}
